<div class="unauthorized-container">
    <div class="unauthorized-content">
      <p>You are not authorized to view this page</p>
    </div>
  </div>
  